import { Component, ViewEncapsulation, Input, Output, EventEmitter, OnDestroy } from '@angular/core';

@Component({
  selector: 'tablesready-opt-in',
  templateUrl: './opt-in.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class OptInComponent implements OnDestroy {
  @Input() useWhatsApp = false;
  @Input() optinType = 'wait';
  @Output() checkedChange = new EventEmitter<{checked: boolean; whatsAppChecked: boolean;}>();
  checked: boolean;
  whatsApp = false;
  providerName = 'SMS';
  whatsAppOptInChecked = false;

  change() {
    this.providerName = this.whatsAppOptInChecked ? 'WhatsApp' : 'SMS';
    this.checkedChange.emit({checked: this.checked, whatsAppChecked: this.whatsAppOptInChecked});
  }

  ngOnDestroy(): void {
    this.checkedChange.complete();
  }
}
